(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _URLHelpers = require('./modules/URLHelpers');

var _GTMEventPush = require('./modules/GTMEventPush');

var _debounce = require('./modules/lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _queryString = require('./modules/queryString');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
	var debugging = (0, _queryString.getParameterByName)('debug');
	function debugLog(message) {
		var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		if (debugging && !error) {
			console.log(message);
		} else if (debugging && error) {
			console.error(message);
		}
	}

	// IE11/Edge ForEach polyfill.
	(function () {
		if (typeof NodeList.prototype.forEach === 'function') return false;
		NodeList.prototype.forEach = Array.prototype.forEach;
	})();

	// IE11 'Includes' polyfill
	if (!String.prototype.includes) {
		String.prototype.includes = function (search, start) {
			if (typeof start !== 'number') {
				start = 0;
			}

			if (start + search.length > this.length) {
				return false;
			} else {
				return this.indexOf(search, start) !== -1;
			}
		};
	}

	// Wait for dom loaded then add global body click listener.
	document.addEventListener('DOMContentLoaded', function () {
		var GTMNotLoaded = false;

		var interval = setInterval(function () {
			if (typeof google_tag_manager == 'undefined' && GTMNotLoaded) {
				debugLog('Error! : Google Tag Manager is not enabled on this page.', true);
				clearInterval(interval);
			} else if (typeof google_tag_manager != 'undefined') {
				clearInterval(interval);
				gtmBind();
			}
		}, 50);

		var gtmBind = function gtmBind() {
			debugLog('Google tag manager script loaded.');
			var variables = {
				touchEvent: '',
				touchStart: 0,
				touchDistance: 0
			};

			// Climbs the parent tree to find the tagged element; if no elements above the targeted element are tagged returns false.
			var parentDataSearch = function parentDataSearch(element) {
				if (typeof element.dataset !== 'undefined' && typeof element.dataset['gtmAction'] !== 'undefined') {
					return element;
				} else {
					while (element.parentNode) {
						element = element.parentNode;
						if (typeof element.dataset !== 'undefined' && typeof element.dataset['gtmAction'] !== 'undefined' || element.nodeName.toLowerCase() == 'a') {
							return element;
						}
					}
				}
				return false;
			};

			// Gets a single data attribute with an undefined check.
			var getDataAttribute = function getDataAttribute(element, attribute) {
				if (typeof element.dataset[attribute] == 'undefined') {
					return false;
				}
				return element.dataset[attribute];
			};

			// Gets all 3 gtm attributes with an undefined check. Returns an object.
			var getDataAttributes = function getDataAttributes(element) {
				var attributeList = {
					gtmAction: typeof element.dataset['gtmAction'] == 'undefined' ? 'default link click' : getDataAttribute(element, 'gtmAction'),
					gtmCategory: typeof element.dataset['gtmCategory'] == 'undefined' ? document.title + ' ~ ' + getPageRoute() : getDataAttribute(element, 'gtmCategory'),
					gtmLabel: typeof element.dataset['gtmLabel'] == 'undefined' ? element.text : getDataAttribute(element, 'gtmLabel'),
					gtmIgnore: typeof element.dataset['gtmIgnore'] == 'undefined' ? false : true
				};

				return attributeList;
			};

			var getPageRoute = function getPageRoute() {
				// Get the default link page route.
				var splitLocation = location.pathname.replace(/\/$/, '').split('/');
				var pathName = splitLocation[splitLocation.length - 1].replace(/-/g, ' ');
				var parentPage = '';

				if (pathName === '' || pathName.toLowerCase().startsWith('default') || pathName.toLowerCase().startsWith('index')) {
					pathName = 'Home Page';
				} else if (pathName.toLowerCase() === 'overview') {
					parentPage = splitLocation[splitLocation.length - 2].replace(/-/g, ' ');
					pathName = parentPage;
				}

				return pathName;
			};

			function touchHandler(event) {
				variables.touchEvent = event.changedTouches[0];
				//event.preventDefault();
			}

			if (typeof document.body.dataset.gtmBinded == 'undefined') {
				// We're gonna detect dragging on the page and nullify our event if the user has dragged.
				document.body.addEventListener('touchstart', touchHandler, true);
				document.body.addEventListener('touchstart', function () {
					variables.touchStart = variables.touchEvent.clientY;
				});
				document.body.addEventListener('touchmove', touchHandler, true);

				// Body click event which tracks all clicks and then crawls up the dom to find out if the element selected was tagged (or its parent was tagged).
				document.body.addEventListener('click', function (e) {
					debouncedEvent(e);
				});
				document.body.addEventListener('touchend', function (e) {
					debouncedEvent(e);
				});

				document.body.dataset.gtmBinded = true;
			}

			// Bind all anchors on the page so that when they're clicked they don't navigate to the location.
			document.querySelectorAll('a').forEach(function (element) {
				if (typeof element.dataset.gtmBinded == 'undefined') {
					element.addEventListener('click', function (event) {

						if (!event.defaultPrevented && !event.ctrlKey && typeof event.target.href !== 'undefined' && event.target.href.indexOf('javascript:') == -1 && event.target.getAttribute('target') !== null && event.target.getAttribute('target').indexOf('_blank') == -1 && typeof window.gaGlobal !== 'undefined') {
							event.preventDefault();
						}
					});
					element.dataset.gtmBinded = true;
				}
			});

			// Here we're going to only send one event through even if the browser is acting naughty and sending 2 events for click and touchend.
			var debouncedEvent = (0, _debounce2.default)(eventClick, 50);

			var eventClick = function eventClick(e) {
				if (e.type == 'touchend') {
					variables.touchDistance = variables.touchStart - variables.touchEvent.clientY;
					if (Math.abs(variables.touchDistance) > 30) {
						debugLog('User swiped; preventing analytics send due to possible false-positive.');
						return false;
					}
				}

				// What was clicked.
				var element = e.target;

				// Ignore and break out if data-gtm-ignore="true".
				if (getDataAttribute(element, 'gtmIgnore')) {
					return;
				}

				// Break out if the user clicked on a p tag or div; we don't want to track these.
				if (getDataAttribute(element, 'gtmWrapper') == 'true') {
					return;
				}
				// Get parent if the targeted element wasn't tagged. Example: <span> within <a>.
				var gtmTaggedElement = parentDataSearch(element);

				if (gtmTaggedElement !== false && typeof getDataAttributes(gtmTaggedElement).gtmAction !== 'undefined') {

					// Get the object containing up-to 3 data attributes.
					var dataAttributes = getDataAttributes(gtmTaggedElement);
					// If the action was click then we're logging it with this event.

					if (dataAttributes.gtmAction.indexOf('click') !== -1) {
						(0, _GTMEventPush.gtmTriggerEvent)(e, gtmTaggedElement, dataAttributes.gtmCategory, dataAttributes.gtmAction, dataAttributes.gtmLabel);
						debugLog(dataAttributes);
					}
				} else
					// If the element is something we want to actually track--An anchor, button or input type submit.
					if (element.nodeName.toLowerCase() == 'a' || element.nodeName.toLowerCase() == 'button' || element.nodeName.toLowerCase() == 'img' || element.nodeName.toLowerCase() == 'svg') {

						// Ignore and break out if data-gtm-ignore="true".
						if (getDataAttribute(element, 'gtmIgnore')) {
							return;
						}

						var pushCategory = document.title + ' ~ ' + getPageRoute();
						var pushAction = 'default link click';
						var pushLabel = element.text;
						debugLog(element);
						if (element.nodeName.toLowerCase() == 'a' && typeof element.attributes.href !== 'undefined') {
							var href = element.attributes.href.value.toLowerCase();

							if (href.indexOf('mailto:') !== -1) {
								debugLog('Email!');
								pushCategory = 'Mailto';
								pushAction = 'click';
								pushLabel = href;
							}
							if (href.indexOf('tel:') !== -1) {
								debugLog('Phone!');
								// Send GTM with defaults for Phone Links.
								pushCategory = 'Phone Number';
								pushAction = 'click to call';
								pushLabel = href;
							}
							if (href.indexOf('.pdf') !== -1) {
								debugLog('Download!');
								// Send GTM with defaults for Download Links.
								pushCategory = 'Download';
								pushAction = 'click';
								pushLabel = href;
							}
							if (((0, _URLHelpers.isExternal)(href) || href == '#' || href == '/') && href.indexOf('tel:') === -1 && href.indexOf('.pdf') && href.indexOf('mailto:')) {
								debugLog('External!');
								// Send GTM with defaults for External Links.
								pushCategory = 'Outbound';
								pushAction = 'click';
								pushLabel = href;
							}
						}

						if (element.nodeName.toLowerCase() == 'img' || element.nodeName.toLowerCase() == 'svg') {
							while (element.parentNode) {
								element = element.parentNode;
								if (element.nodeName.toLowerCase() == 'a') {
									var text = element.text.replace(/^\s+|\s+$/gi, '').replace(/\\r\\n+/g, '').replace(/\r?\n|\r/g, '');
									if (text == '') {
										if (typeof element.querySelector('img').attributes.alt !== 'undefined') {
											pushLabel = 'Image Alt Text: ' + element.querySelector('img').attributes.alt.value;
										} else {
											pushLabel = 'No Alt Text Available.';
										}
									}
								}
							}
						}

						if (element.nodeName.toLowerCase() == 'button' || element.nodeName.toLowerCase() == 'input' && element.attributes.type.value == 'submit') {
							pushLabel = element.textContent;
						}

						// Get the default label. (Alt text for images, text for links or other tracked elements).
						debugLog(element);
						(0, _GTMEventPush.gtmTriggerEvent)(e, element, pushCategory, pushAction, pushLabel);
						debugLog('sending GTM with defaults');
					}
			};

			document.querySelectorAll('select, input[type="checkbox"]').forEach(function (e) {
				if (typeof e.dataset.gtmBinded == 'undefined') {
					e.dataset.gtmBinded = true;
					e.addEventListener('change', function (e) {
						var dataAttributes = getDataAttributes(e.target);
						debugLog(dataAttributes);
						// If we've tagged this <select> then use it's data (ignoring Label.) Else we'll just use the defaults: page route, change and the label is the selected options text.
						if (typeof e.target.dataset['gtmAction'] !== 'undefined') {
							(0, _GTMEventPush.gtmTriggerEvent)(e, e.target, dataAttributes.gtmCategory, dataAttributes.gtmAction, 'Selected: ' + e.target.options[e.target.selectedIndex].text);
						} else {
							(0, _GTMEventPush.gtmTriggerEvent)(e, e.target, document.title + ' ~ ' + getPageRoute(), 'change', 'Selected: ' + e.target.options[e.target.selectedIndex].text);
						}
					});
				}
			});
		};

		var target = document.body;
		var reBind = (0, _debounce2.default)(gtmBind, 250);

		// Setup observer for dom elements that require a listener and rebind them after dom changes.
		var observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				// Rebind the events to all anchors anytime an element on the dom changes.
				// Re-work this to be a bit more performant; currently our mutations we're attached to are far too overreaching.
				if (typeof google_tag_manager != 'undefined') {
					reBind();
				}
			});
		});

		// configuration of the observer:
		var config = { childList: true, attributes: true, subtree: true };

		// pass in the target node, as well as the observer options
		observer.observe(target, config);
	});
})();

},{"./modules/GTMEventPush":2,"./modules/URLHelpers":3,"./modules/lodash/debounce":10,"./modules/queryString":16}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var gtmTriggerEvent = exports.gtmTriggerEvent = function gtmTriggerEvent(event, eventTarget, category, action, label) {
	dataLayer.push({
		'event': 'GenericEvent', 'eventCategory': category, 'eventAction': action, 'eventLabel': label, 'eventCallback': function eventCallback() {
			var frameworkTest = false;
			[].slice.call(eventTarget.attributes).forEach(function (e) {
				if (e.nodeName.indexOf('ng-') !== -1 || e.nodeName.indexOf('v-') !== -1) {
					frameworkTest = true;
				}
			});
			if (eventTarget.getAttribute('href') !== null && eventTarget.getAttribute('href').indexOf('javascript:') == -1 && eventTarget.getAttribute('target') !== null && eventTarget.getAttribute('target').indexOf('_blank') == -1 && !event.ctrlKey && !frameworkTest) {
				window.location.assign(eventTarget.href);
				return false;
			}
		} });
};

},{}],3:[function(require,module,exports){
'use strict';

// Pulled from:
// https://stackoverflow.com/a/28054735

Object.defineProperty(exports, "__esModule", {
	value: true
});
var checkDomain = exports.checkDomain = function checkDomain(url) {
	if (url.indexOf('//') === 0) {
		url = location.protocol + url;
	}
	return url.toLowerCase().replace(/([a-z])?:\/\//, '$1').split('/')[0];
};

var isExternal = exports.isExternal = function isExternal(url) {
	return (url.indexOf(':') > -1 || url.indexOf('//') > -1) && checkDomain(location.href) !== checkDomain(url);
};

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = require('./_root.js');

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Built-in value references. */
var _Symbol = _root2.default.Symbol;

exports.default = _Symbol;

},{"./_root.js":9}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Symbol2 = require('./_Symbol.js');

var _Symbol3 = _interopRequireDefault(_Symbol2);

var _getRawTag = require('./_getRawTag.js');

var _getRawTag2 = _interopRequireDefault(_getRawTag);

var _objectToString = require('./_objectToString.js');

var _objectToString2 = _interopRequireDefault(_objectToString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol3.default ? _Symbol3.default.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTag2.default)(value) : (0, _objectToString2.default)(value);
}

exports.default = baseGetTag;

},{"./_Symbol.js":4,"./_getRawTag.js":7,"./_objectToString.js":8}],6:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

exports.default = freeGlobal;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Symbol2 = require('./_Symbol.js');

var _Symbol3 = _interopRequireDefault(_Symbol2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol3.default ? _Symbol3.default.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

exports.default = getRawTag;

},{"./_Symbol.js":4}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

exports.default = objectToString;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _freeGlobal = require('./_freeGlobal.js');

var _freeGlobal2 = _interopRequireDefault(_freeGlobal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal2.default || freeSelf || Function('return this')();

exports.default = root;

},{"./_freeGlobal.js":6}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject = require('./isObject.js');

var _isObject2 = _interopRequireDefault(_isObject);

var _now = require('./now.js');

var _now2 = _interopRequireDefault(_now);

var _toNumber = require('./toNumber.js');

var _toNumber2 = _interopRequireDefault(_toNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = (0, _toNumber2.default)(wait) || 0;
  if ((0, _isObject2.default)(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax((0, _toNumber2.default)(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = (0, _now2.default)();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge((0, _now2.default)());
  }

  function debounced() {
    var time = (0, _now2.default)(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

exports.default = debounce;

},{"./isObject.js":11,"./now.js":14,"./toNumber.js":15}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

exports.default = isObject;

},{}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

exports.default = isObjectLike;

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _baseGetTag = require('./_baseGetTag.js');

var _baseGetTag2 = _interopRequireDefault(_baseGetTag);

var _isObjectLike = require('./isObjectLike.js');

var _isObjectLike2 = _interopRequireDefault(_isObjectLike);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || (0, _isObjectLike2.default)(value) && (0, _baseGetTag2.default)(value) == symbolTag;
}

exports.default = isSymbol;

},{"./_baseGetTag.js":5,"./isObjectLike.js":12}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = require('./_root.js');

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return _root2.default.Date.now();
};

exports.default = now;

},{"./_root.js":9}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject = require('./isObject.js');

var _isObject2 = _interopRequireDefault(_isObject);

var _isSymbol = require('./isSymbol.js');

var _isSymbol2 = _interopRequireDefault(_isSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if ((0, _isSymbol2.default)(value)) {
    return NAN;
  }
  if ((0, _isObject2.default)(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = (0, _isObject2.default)(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

exports.default = toNumber;

},{"./isObject.js":11,"./isSymbol.js":13}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var getParameterByName = exports.getParameterByName = function getParameterByName(name) {
	var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

},{}]},{},[1]);
